import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpInternalService } from './http.service';

/**
 * The bank accounts the Transactions screen hides, for everyone in the organisation
 * (api/transactions/account-visibility). Only that screen reads it: hiding an account changes
 * nothing about the account, its feed or its transactions anywhere else.
 */
@Injectable({
  providedIn: 'root'
})
export class BankAccountVisibilityService {

  constructor(private _httpService: HttpInternalService) { }

  hiddenAccountIds(organisationId: string): Observable<string[]> {
    return this._httpService.getRequest<{ hiddenAccountIds: string[] }>('transactions/account-visibility', { organisationId })
      .pipe(map(res => (res && res.hiddenAccountIds) || []));
  }

  setHidden(organisationId: string, accountId: string, hidden: boolean): Observable<any> {
    return this._httpService.putRequest(
      `transactions/account-visibility?organisationId=${encodeURIComponent(organisationId)}`, { accountId, hidden });
  }
}
